import { Directive, Output, EventEmitter, ElementRef, Input, HostListener } from "@angular/core";

@Directive({
  selector: "input[uploadInputFor],div[uploadInputFor], form[uploadInputFor], span[uploadInputFor]"
})
export class UploadDirective {
  private _queue: any = null;
  private _element: HTMLElement;
  private _inputId: number;
  @Output() public onFileSelected: EventEmitter<File[]> = new EventEmitter<File[]>();

  constructor(private element: ElementRef) {
    this._element = this.element.nativeElement;
  }

  @Input("uploadInputFor")
  set fileUploadQueue(value: any) {
    if (value) {
      this._queue = value;
    }
  }

  @Input("inputId")
  set inputId(value: number) {
    this._inputId = value;
  }

  @HostListener("change")
  public onChange(): any {
    console.log(this._inputId);
    let files = this.element.nativeElement.files;
    this.onFileSelected.emit(files);

    if (this._queue && this._queue.addFiles && files) {
      this._queue.addFiles(files);
    }
    else if (this._queue && this._queue.addFile && files) {
      for (var i = 0; i < files.length; i++) {
        this._queue.addFile(files[i]);
      }
    }
    this.element.nativeElement.value = "";
  }

  @HostListener("drop", ["$event"])
  public onDrop(event: any): any {
    let files = event.dataTransfer.files;
    this.onFileSelected.emit(files);
    if (this._queue && this._queue.addFiles && files) {
      this._queue.addFiles(files);
    }
    else if (this._queue && this._queue.addFile) {
      for (var i = 0; i < files.length; i++) {
        this._queue.addFile(files[i]);
      }
    }
    event.preventDefault();
    event.stopPropagation();
    this.element.nativeElement.value = "";
  }

  @HostListener("dragover", ["$event"])
  public onDropOver(event: any): any {
    event.preventDefault();
  }
}
